import { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

/**
 * Company selection component using MUI Autocomplete
 * @param {props} headerText - text displayed in the h5 
 * @param {props} selectText - text displayed in label of Select
 * @param {props} selectedCompany - stateful selected company
 * @param {props} setSelectedCompany - set of stateful
 * @param {props} allCompanies - passed in set of companies for select
 * @param {props} showAllCompanies - display all/subset companies
 * @param {props} onChange - allows you to hook up to a function call in the parent
 * @returns {JSX.Element} Company selection component
 */

export default function CompanyAutoselect(props) {
    const [companies, setCompanies] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        if (props.allCompanies?.length > 0) {
            let mappedCompanies = props.allCompanies.map((company) => ({
                label: company.companyName,
                id: company.companyId,
                ...company
            }));
            
            mappedCompanies = props.showAllCompanies?mappedCompanies:mappedCompanies.filter((company)=>company.peerGroupId===null);
            setCompanies(mappedCompanies);

            // Set initial selection if selectedCompany is provided
            if (props.selectedCompany) {
                console.log('CompanyAutoselect: selectedCompany prop is:', props.selectedCompany);
                const initialSelection = mappedCompanies.find(
                    (company) => company.id == props.selectedCompany // Use == for type coercion
                );
                console.log('CompanyAutoselect: found initial selection:', initialSelection);
                setSelectedOption(initialSelection || null);
            } else {
                console.log('CompanyAutoselect: no selectedCompany prop or it is 0/null');
                setSelectedOption(null);
            }
        }
    }, [props.allCompanies, props.selectedCompany]);

    const handleChange = (event, newValue) => {
        setSelectedOption(newValue);

        if (newValue) {
            if (props.setSelectedCompany) {
                props.setSelectedCompany(newValue.id);
            }
            if (props.onChange) {
                props.onChange(newValue);
            }
        } else {
            // Handle clearing selection
            if (props.setSelectedCompany) {
                props.setSelectedCompany(0);
            }
            if (props.onChange) {
                props.onChange(0);
            }
        }
    };

    return (
        <div>
            {props.headerText && <h5>{props.headerText}</h5>}
            <Autocomplete
                value={selectedOption}
                onChange={handleChange}
                options={companies}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={props.selectText || "Select Company"}
                        variant="outlined"
                    />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                clearOnBlur={false}
                clearOnEscape
            />
        </div>
    );
}
